import { jsxs as e, jsx as g } from "react/jsx-runtime";
function r(c) {
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...c,
      children: [
        /* @__PURE__ */ g("g", { children: /* @__PURE__ */ g("g", { children: /* @__PURE__ */ g("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ g("g", { children: /* @__PURE__ */ g("g", { children: /* @__PURE__ */ g("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {}),
        /* @__PURE__ */ g("g", {})
      ]
    }
  );
}
export {
  r as default
};
